const title = 'Post Jobs – The easiest way to keep track on jobs.';
const description = 'Trying to learn NextJs.';

const SEO = {
  title,
  description
};

export default SEO;
